import { Player } from '../../classes/Player';
import { Portal } from 'src/classes/Portal';
import VirtualJoyStick from 'phaser3-rex-plugins/plugins/virtualjoystick';
import BaseLevelScene from './BaseLevelScene';

export default class CatacombScene extends BaseLevelScene {
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  exits: Portal[] = [];
  expandedMaze: Array<Array<integer>>;
  player: Player;
  joystick: VirtualJoyStick;

  constructor() {
    super("James Monroe's Grave");
  }
  preload() {

    // preload base level
    this.preloadBaseLevel();

    // load the PNG file
    this.load.image('catacomb', 'assets/sourceImages/mainlevbuild.png');

    // load the JSON map
    this.load.tilemapTiledJSON(
      'catacomb_tilemap',
      'assets/scenes/catacomb.json'
    );

    // Load portal assets
    Portal.preload(this);
  }

  create() {
    // 👌 sanity check by displaying the entire tileset image
    // this.add.image(0, 0, 'catacomb');

    // create the Tilemap
    this.map = this.make.tilemap({ key: 'catacomb_tilemap' });

    // add the tileset image we are using
    const tileset = this.map.addTilesetImage('catacomb', 'catacomb');

    // create the layers we want in the right order
    const floor = this.map.createLayer('floor', tileset);
    floor.setCollisionByProperty({ collides: true });
    this.matter.world.convertTilemapLayer(floor);

    // "Ground" layer will be on top of "Background" layer
    const landscapes = this.map.createLayer('landscapes', tileset);
    landscapes.setCollisionByProperty({ collides: true });
    this.matter.world.convertTilemapLayer(landscapes);

    // create base level
    this.createBaseLevel(0.4, 4);
  }

}
